/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S3_Li1Inputs */

const tr_iade_iptal_s3_li1 = /** @type {(inputs: Iade_Iptal_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirim için önceden haber verme süresi yoktur. İptal, ödenen dönemin sonunda hüküm doğurur; Fesih, Abone'nin açık talebi halinde bildirimin Sağlayıcı'ya ulaşmasıyla derhal hüküm doğurur (2. maddedeki tanımlar); teknik kapatma işlemi Abonelik Sözleşmeleri Yönetmeliği Madde 24 uyarınca en geç 7 (yedi) gün içinde tamamlanır.`)
};

const en_iade_iptal_s3_li1 = /** @type {(inputs: Iade_Iptal_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No advance notice period applies. Cancellation takes effect at the end of the paid period; Termination, at the Subscriber's express request, takes effect immediately upon receipt of the notice by the Provider (definitions in clause 2); the technical shutdown is completed within 7 (seven) days at the latest in accordance with Abonelik Sözleşmeleri Yönetmeliği Madde 24.`)
};

const de_iade_iptal_s3_li1 = /** @type {(inputs: Iade_Iptal_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gibt keine Vorankündigungsfrist. Die Kündigung wird zum Ende des bezahlten Zeitraums wirksam; die Beendigung wird auf ausdrücklichen Wunsch des Abonnenten mit Zugang der Mitteilung beim Anbieter sofort wirksam (Begriffe in Ziffer 2); die technische Abschaltung wird gemäß Abonelik Sözleşmeleri Yönetmeliği Madde 24 spätestens innerhalb von 7 (sieben) Tagen abgeschlossen.`)
};

const ru_iade_iptal_s3_li1 = /** @type {(inputs: Iade_Iptal_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок предварительного уведомления не установлен. Отмена вступает в силу по окончании оплаченного периода; Расторжение по явному требованию Абонента вступает в силу немедленно с момента получения уведомления Поставщиком (определения в пункте 2); техническое отключение завершается не позднее 7 (семи) дней в соответствии с Abonelik Sözleşmeleri Yönetmeliği Madde 24.`)
};

/**
* | output |
* | --- |
* | "No advance notice period applies. Cancellation takes effect at the end of the paid period; Termination, at the Subscriber's express request, takes effect imm..." |
*
* @param {Iade_Iptal_S3_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s3_li1 = /** @type {((inputs?: Iade_Iptal_S3_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S3_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s3_li1(inputs)
	if (locale === "de") return de_iade_iptal_s3_li1(inputs)
	if (locale === "ru") return ru_iade_iptal_s3_li1(inputs)
	return tr_iade_iptal_s3_li1(inputs)
});